import { IBaseDesignerConfig } from "../common/base-designer-config";

export enum SettingTypeEnum {
  ApiConnection = 1,
  Scalar = 2
}

export enum ValueTypeEnum {
  boolean = 2,
  date = 5,
  number = 4,
  string = 3,
  time = 6,
}

export enum ApiConnectionTypeEnum {
  FootPrintApi = 1,
  MongoDb = 8,
  Amqp = 9,
  Sftp = 10,
  Tcp = 11,
  MsSql = 12
}

export function getApiConnectionTypeLabel(type: ApiConnectionTypeEnum): string {
  return ApiConnectionTypeEnum[type] ?? type?.toString();
}

export function getValueTypeLabel(type: ValueTypeEnum): string {
  return ValueTypeEnum[type] ?? type?.toString();
}

export interface IAppConfigSetting {
  name: string;
  description: string;
  settingType: SettingTypeEnum;
  valueType: ValueTypeEnum | null;
  value: any;
  apiConnectionType: ApiConnectionTypeEnum | null;
  apiConnectionName: string | null;
}

export interface IAppConfigReference {
  uniqueIdentifier: string;
  referenceName: string;
  version: string;
  isDirect: boolean;
  settings: IAppConfigSetting[];
  settingsMappings: Array<{ from: string, to: string }>;
}

export interface IAppConfigDesignerConfig extends IBaseDesignerConfig {
  settings: IAppConfigSetting[];
  references: IAppConfigReference[];
}

export function getFootPrintApiSettings(settings: IAppConfigSetting[]): IAppConfigSetting[] {
  return settings?.filter(s =>
    s.settingType === SettingTypeEnum.ApiConnection &&
    s.apiConnectionType === ApiConnectionTypeEnum.FootPrintApi
  ) ?? [];
}